/**
 * Office Map Pins
 */
class Pin {
  constructor(el, map) {
    this.el = el;
    this.map = map;
    this.active = false;
    this.init();
    this.bind();
  }

  init() {
    var meta = JSON.parse(this.el.getAttribute('data-pin'));
    this.data = meta;
    this.data.name = this.el.getAttribute('data-name');
    this.label = this.el.getAttribute('data-label');
  }

  bind() {
    this.el.addEventListener('click', e => this.setActive(e));
  }

  setActive(e) {
    this.map.setActive(this);
  }

  toggle(active) {
    this.active = active;
    this.el.classList.toggle('is-active');
  }
}

export default Pin;



// WEBPACK FOOTER //
// ./scripts/components/pin.js